import React from 'react'
import { FooterBackground , FooterSection, FooterTitle, FooterSubtitle, FooterLinksWrapper, FooterLink, FooterSocialsWrapper, FooterSocial, FooterCopyright, FooterContainer} from './FooterStyles'
import { UilFacebookF,UilInstagram ,UilTwitterAlt  } from '@iconscout/react-unicons';

const Footer = () => {
    return (
        <FooterSection>
            <FooterBackground>
              <FooterContainer>
                <div>
                    <FooterTitle>Oji</FooterTitle>
                    <FooterSubtitle>Fullstack Developer</FooterSubtitle>
                </div>
                <FooterLinksWrapper>
                    <li>
                        <FooterLink 
                            to="services-section"
                            activeClass="active"
                            spy={true}
                            smooth={true}
                            offset={50}
                            duration={300}
                            hashSpy={true}
                        >Services</FooterLink>
                    </li>
                    <li>
                        <FooterLink 
                            to="portfolio-section"
                            activeClass="active"
                            spy={true}
                            smooth={true}
                            offset={50}
                            duration={300}
                            hashSpy={true}
                        >Portfolio</FooterLink>
                    </li>
                    <li>
                        <FooterLink 
                            to="contact-section"
                            activeClass="active"
                            spy={true}
                            smooth={true}
                            offset={50}
                            duration={300}
                            hashSpy={true}
                        >Contactme</FooterLink>
                    </li>
                </FooterLinksWrapper>
                <FooterSocialsWrapper>
                    <FooterSocial 
                        to={{ pathname: "https://www.facebook.com/" }}
                        target="_blank"
                        className="link"
                    >
                        <UilFacebookF size="1.25rem" className="social__icon"/>
                    </FooterSocial>
                    <FooterSocial 
                        to={{ pathname: "https://www.instagram.com/" }}
                        target="_blank"
                        className="link"
                    >
                        <UilInstagram  size="1.25rem" className="social__icon"/>
                    </FooterSocial>
                    <FooterSocial 
                        to={{ pathname: "https://www.twitter.com/" }}
                        target="_blank"
                        className="link"
                    > 
                        <UilTwitterAlt  size="1.25rem" className="social__icon"/>
                    </FooterSocial>
                </FooterSocialsWrapper>

                <FooterCopyright>
                    &#169; Motif Dev. All right reserved
                </FooterCopyright>
              </FooterContainer>
            </FooterBackground>
        </FooterSection>
    )
}

export default Footer